import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task-routine",
  "use": "task-routine-usage",
  "viewBox": "0 0 27.7 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.7 27\" id=\"task-routine\"><path d=\"M23.2 22.6c2.3-2.1 3.9-5.2 4-8.5.1-6.5-5.1-11.8-11.6-11.9v2.1c5.3.1 9.4 4.4 9.3 9.6 0 2.8-1.3 5.2-3.3 7l-3.5-3.4-.1 8.1 8.1.1-2.9-3.1zM14.7 13.2l-1.6-1.6-.9-1.2c.3-.8.5-1.6.5-2.4 0-3.2-2.6-5.8-5.8-5.8-.7 0-1.4.1-2.1.4L9.2 7l-3.3 3.3-4.4-4.5c-.3.7-.4 1.4-.4 2.1 0 3.2 2.6 5.8 5.8 5.8.6 0 1.2-.1 1.8-.3l1.1 1.4 1.6 1.6 3 3.4\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/task-routine.svg
// module id = VsBK
// module chunks = 1